export default __webpack_public_path__ + "images/benefits-of-collaboration.svg";